var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10",
    "data-name": "Group 10",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M27.125,0H3.875A3.879,3.879,0,0,0,0,3.875v23.25A3.879,3.879,0,0,0,3.875,31h23.25A3.879,3.879,0,0,0,31,27.125V3.875A3.879,3.879,0,0,0,27.125,0Z",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M207.072,106.048h-5.024v-4.019c0-1.109.9-1,2.01-1h2.01V96h-4.019a6.028,6.028,0,0,0-6.029,6.029v4.019H192v5.024h4.019v11.053h6.029V111.072h3.014Z",
    transform: "translate(-180.757 -91.124)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_facebook.a206f348e1af505b3859549f725ec148.svg";
export { ForwardRef as ReactComponent };